module.exports = __webpack_public_path__ + "static/media/accept-remote.fa4499eb.jpg";